import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl
} from "@mui/material";
// import PhoneInput from "react-phone-input-2";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup
} from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../utils/countriesDropdown";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../components/CustomButton/CustomButton";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import BackButton from "../../components/BackButton/BackButton";
import { getWalletOwnerSettingDetails } from "../../redux/actions/getWalletOwnerSettingDetailsAction";
import { updateWalletOwnerSettingDetails } from "../../redux/actions/updateWalletOwnerSettingDetailsAction";
import { getThemeList } from "../../redux/actions/getThemeListAction";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import Util from "../../validation/index";
import { getWalletOwnerSMSProvider } from "../../redux/actions/getWalletOwnerSmsProviderAction";
import { getSMSProvider } from "../../redux/actions/getSmsProviderAdminAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const AdminWalletOwnerUpdate = () => {
	const navigate = useHistory();

	const location = useLocation();
	const WalletOwnerId = location.search.split("?userId=")[1];
	console.log(WalletOwnerId);
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const dispatch = useDispatch();

	const getOwnerSettingRes = useSelector(
		({ getWalletOwnerSettingDetails }) => getWalletOwnerSettingDetails
	);

	const updateOwnerSettingRes = useSelector(
		({ updateWalletOwnerSettingDetails }) => updateWalletOwnerSettingDetails
	);

	const getWalletOwnerSmsProviderRes = useSelector(
		({ getWalletOwnerSmsProvider }) => getWalletOwnerSmsProvider
	);

	const getSMSProviderList = useSelector(
		({ adminGetSmsProviderSuccessList }) => (adminGetSmsProviderSuccessList)
	)

	console.log(getSMSProviderList, "getWalletOwnerSmsProviderRessss");
	// console.log(getWalletOwnerSmsProviderRes, "getWalletOwnerSmsProviderRes");

	const [getWalletOwnerStatus, setGetWalletOwnerStatus] = useState(false);
	const [getWalletOwnerSettingArray, setGetWalletOwnerSettingArray] =
		useState("");

	const [updateWalletOwnerSettingStatus, setUpdateWalletOwnerSettingStatus] =
		useState(false);
	const [updateWalletOwnerSettingArray, setUpdateWalletOwnerSettingArray] =
		useState([]);

	const [walletOwnerTableArray, setWalletOwnerTableArray] = useState([]);
	const [walletOwnerTableStatus, setWalletOwnerTableStatus] = useState(false);

	const [notificationOpen, setNotificationOpen] = useState(false);

	const [user, setUser] = useState({
		ownerID: "",
		walletOwnerName: "",
		SMTPHost: "",
		EmailFrom: "",
		EmailSubjectOnReg: "",
		SmsContentOnReg: "",
		SmsFrom: "",
		SmsToken: "",
		SmsPassword: "",
		SmsProvider: "",
		EmailProvider: "",
		SmsContentOnOtp: "",
		EmailContentOnReg: "",
		SMTPPort: "",
		SmsSecret: "",
		SMTPPassword: "",
		SmsUrl: "",
		SmsUser: "",
		SMTPUserName: "",
		EmailContentOnOtp: ""
	});

	const {
		ownerID,
		walletOwnerName,
		SMTPHost,
		EmailFrom,
		EmailSubjectOnReg,
		SmsContentOnReg,
		SmsFrom,
		SmsToken,
		SmsPassword,
		SmsProvider,
		EmailProvider,
		SmsContentOnOtp,
		EmailContentOnReg,
		SMTPPort,
		SmsSecret,
		SMTPPassword,
		SmsUrl,
		SmsUser,
		SMTPUserName,
		EmailContentOnOtp
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = value
		}
		setUser(obj);
		console.log('Change: ', obj);
	};

	// view api

	const getWalletOwnerIdAndNameStatusFunc = () => {
		setGetWalletOwnerStatus(true);
		const req = {
			loginDetails: {
				// adminId: "2"
				adminId: val.adminIDS,

			},
			ownerMasterRequestVO: {
				ownerID: WalletOwnerId
			}
		};
		return dispatch(
			getWalletOwnerSettingDetails(req, regenerateTokenRes.data.AuthToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameStatusFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const getWalletOwnerFunc = () => {
		if (getWalletOwnerStatus) {
			if (getOwnerSettingRes.data.status == "success") {
				setGetWalletOwnerSettingArray(
					getOwnerSettingRes.data.walletOwnerSettings
				);
				setNotificationOpen(true);
			}
			if (getOwnerSettingRes.data.status == "failed") {
				setGetWalletOwnerSettingArray(getOwnerSettingRes.data);
				setNotificationOpen(true);
				if (
					getOwnerSettingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getOwnerSettingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getWalletOwnerFunc();
	}, [getOwnerSettingRes]);

	useEffect(() => {
		if (getOwnerSettingRes.data.walletOwnerSettings != null) {
			setUser({
				ownerID: getWalletOwnerSettingArray.adminId,
				SMTPHost: getWalletOwnerSettingArray.smtpHost,
				EmailFrom: getWalletOwnerSettingArray.emailFrom,
				EmailSubjectOnReg: getWalletOwnerSettingArray.isEMAILSubjectOnReg,
				SmsContentOnReg: getWalletOwnerSettingArray.isSMSContentOnReg,
				SmsFrom: getWalletOwnerSettingArray.isSMSFrom,
				SmsToken: getWalletOwnerSettingArray.smsToken == "-" ? "" : getWalletOwnerSettingArray.smsToken,
				SmsPassword: getWalletOwnerSettingArray.isSMSPassword,
				SmsProvider: getWalletOwnerSettingArray.smsProvider,
				EmailProvider: getWalletOwnerSettingArray.emailProvider,
				SmsContentOnOtp: getWalletOwnerSettingArray.isSMSContentOnOtp,
				EmailContentOnReg: getWalletOwnerSettingArray.isEMAILContentOnReg,
				SMTPPort: getWalletOwnerSettingArray.smtpPort,
				SmsSecret: getWalletOwnerSettingArray.smsSecret == "-" ? "" : getWalletOwnerSettingArray.smsSecret,
				SMTPPassword: getWalletOwnerSettingArray.smtpPass,
				SmsUrl: getWalletOwnerSettingArray.isSMSUrl,
				SmsUser: getWalletOwnerSettingArray.isSMSUser,
				SMTPUserName: getWalletOwnerSettingArray.smtpUser,
				EmailContentOnOtp: getWalletOwnerSettingArray.isEMAILContentOnOtp
			});
		} else {
			setUser({
				ownerID: "",
				SMTPHost: "",
				EmailFrom: "",
				EmailSubjectOnReg: "",
				SmsContentOnReg: "",
				SmsFrom: "",
				SmsToken: "",
				SmsPassword: "",
				SmsContentOnOtp: "",
				EmailContentOnReg: "",
				SMTPPort: "",
				SmsSecret: "",
				SMTPPassword: "",
				SmsUrl: "",
				SmsUser: "",
				SMTPUserName: "",
				EmailContentOnOtp: ""
			});
		}
	}, [getWalletOwnerSettingArray]);

	// update api

	const updateWalletOwnerRequest = () => {
		setUpdateWalletOwnerSettingStatus(true);

		const req = {
			// adminId: 2,
			adminId: val.adminIDS,

			walletOwnerId: WalletOwnerId,
			smsProvider: SmsProvider,
			emailProvider: EmailProvider,
			isSMSUrl: SmsUrl,
			smsToken: SmsToken,
			smsSecret: SmsSecret,
			isSMSUser: SmsUser,
			isSMSPassword: SmsPassword,
			isSMSFrom: SmsFrom,
			isSMSContentOnReg: SmsContentOnReg,
			isSMSContentOnOtp: SmsContentOnOtp,
			isEMAILContentOnReg: EmailContentOnReg,
			isEMAILSubjectOnReg: EmailSubjectOnReg,
			isEMAILContentOnOtp: EmailContentOnOtp,
			smtpHost: SMTPHost,
			smtpPort: SMTPPort,
			emailFrom: EmailFrom,
			smtpUser: SMTPUserName,
			smtpPass: SMTPPassword
		};
		dispatch(updateWalletOwnerSettingDetails(req, authToken));
	};

	// useEffect(() => {
	//     updateWalletOwnerRequest();
	// }, []);

	const updateWalletOwnerFunc = () => {
		if (updateWalletOwnerSettingStatus) {
			if (updateOwnerSettingRes.data.status == "success") {
				setUpdateWalletOwnerSettingArray(updateOwnerSettingRes.data);
				setNotificationOpen(true);
				// updateWalletOwnerRequest()
				// getWalletOwnerIdAndNameStatusFunc()
				getWalletOwnerIdAndNameListRequest();
			}
			if (updateOwnerSettingRes.data.status == "failed") {
				setUpdateWalletOwnerSettingArray(updateOwnerSettingRes.data);
				setNotificationOpen(true);
				if (
					updateOwnerSettingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateOwnerSettingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateWalletOwnerFunc();
	}, [updateOwnerSettingRes.data.status]);

	const handleClose = () => {
		if (updateOwnerSettingRes.data.status == "success") {
			navigate.push({
				pathname: `/index/wallet-owner-settings`
			});
			getWalletOwnerIdAndNameListRequest();
		}
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		if (updateOwnerSettingRes.data.status == "success") {
			navigate.push({
				pathname: `/index/wallet-owner-settings`
			});
			getWalletOwnerIdAndNameListRequest();
		}
	};

	// search api
	const getOwnerAndNameList = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const getWalletOwnerIdAndNameListRequest = () => {
		setWalletOwnerTableStatus(true);
		const getWalletOwnerIdAndNameListReq = {
			loginDetails: {
				// adminId: 2
				adminId: val.adminIDS,

			}
		};
		dispatch(
			getWalletOwnerIdAndNameList(getWalletOwnerIdAndNameListReq, authToken)
		);
	};

	const getWalletOwnerListResFunc = () => {
		if (walletOwnerTableStatus) {
			if (getOwnerAndNameList.data.status == "success") {
				setWalletOwnerTableArray(getOwnerAndNameList.data.ownerList);
			}
			if (getOwnerAndNameList.data.status === "failed") {
				setWalletOwnerTableArray(getOwnerAndNameList.data.ownerList);
				if (
					getOwnerAndNameList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getOwnerAndNameList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		// if (walletOwnerTableStatus) {
		getWalletOwnerListResFunc();
		// }
	}, [getOwnerAndNameList.data.status]);

	const getWalletOwnerSmsProviderReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: WalletOwnerId,
				name: SmsProvider,
				// adminId: "2",
				adminId: val.adminIDS,

			}
		};
		dispatch(getSMSProvider(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerSmsProviderReq();
		}
	}, [regenerateTokenRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<br />
					<Grid container>
						<Grid item xs={12} lg={12} md={12} sm={12}>
							<h6 align="center" className="text-center themeText">
								{" "}
								Owner Settings
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="Owner ID"
								type="text"
								fullWidth
								variant="standard"
								value={WalletOwnerId || ""}
								name="WalletOwnerId"
								onChange={onInputChange}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>

						<Grid container style={{ padding: "10px" }}>
							<Grid
								item
								xs={12}
								lg={12}
								md={12}
								sm={12}
								className="tableHeaderColor"
								style={{
									marginTop: "36px",
									padding: "10px",
									// backgroundColor: "#00b9f5",
									// color: "#fff"
								}}
							>
								<h6 align="center" className="text-center tableHeaderColor" >
									{" "}
									SMS Configuration
								</h6>
							</Grid>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} md={8} lg={8}>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Sms Provider"
												fullWidth={true}
												name="SmsProvider"
												value={SmsProvider || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											>
												{console.log(getSMSProviderList, "getSMSProviderListttttt")}
												{getSMSProviderList.data.status ==
													"success" &&
													getSMSProviderList.data &&
													getSMSProviderList.data.smsProviderList &&
													[]
														.concat(
															getSMSProviderList.data.smsProviderList
														)
														.map((x) => (
															<MenuItem key={x.id} value={x.name}>
																{x.name}
															</MenuItem>
														))}
											</TextField>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									<TextField
										size="small"
										color="primary"
										autoFocus={true}
										variant="standard"

										label="Sms URL"
										fullWidth={true}
										name="SmsUrl"
										value={SmsUrl || ""}
										onChange={(e) => onInputChange(e)}
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}
									/>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="Sms Token"
												variant="standard"

												fullWidth={true}
												name="SmsToken"
												value={SmsToken}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="Sms Secret"
												variant="standard"
												fullWidth={true}
												name="SmsSecret"
												value={SmsSecret || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="Sms User"
												variant="standard"

												fullWidth={true}
												name="SmsUser"
												value={SmsUser || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										autoFocus={true}
										type="string"
										label="Sms Password"
										variant="standard"

										fullWidth={true}
										name="SmsPassword"
										value={SmsPassword || ""}
										onChange={(e) => onInputChange(e)}
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}
									></TextField>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="Sms From"
												variant="standard"

												fullWidth={true}
												name="SmsFrom"
												value={SmsFrom || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "alphabet")}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="Sms Content On Reg"
												fullWidth={true}
												name="SmsContentOnReg"
												value={SmsContentOnReg || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="Sms Content On Otp"
												fullWidth={true}
												name="SmsContentOnOtp"
												value={SmsContentOnOtp || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
							</Grid>

							<Grid
								item
								xs={12}
								lg={12}
								md={12}
								sm={12}
								className="tableHeaderColor"
								style={{
									marginTop: "36px",
									padding: "10px",
									// backgroundColor: "#00b9f5",
									// color: "#fff"
								}}
							>
								<h6 align="center" className="text-center" style={{ color: "#fff" }}>
									{" "}
									Email Configuration
								</h6>
							</Grid>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} md={8} lg={8}>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Email Provider"
												fullWidth={true}
												name="EmailProvider"
												value={EmailProvider || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											>
												<MenuItem value="">Select Email Provider</MenuItem>
												<MenuItem value="SMTP">SMTP</MenuItem>
												<MenuItem value="SENDGRID">SENDGRID</MenuItem>
											</TextField>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												variant="standard"

												autoFocus={true}
												label="Email Content On Reg"
												fullWidth={true}
												name="EmailContentOnReg"
												value={EmailContentOnReg || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									<TextField
										size="small"
										color="primary"
										autoFocus={true}
										variant="standard"

										label="Email Subject On Reg"
										fullWidth={true}
										name="EmailSubjectOnReg"
										value={EmailSubjectOnReg || ""}
										onChange={(e) => onInputChange(e)}
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}
									/>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="Email Content On Otp"
												fullWidth={true}
												name="EmailContentOnOtp"
												value={EmailContentOnOtp || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="SMTP Host"
												variant="standard"
												fullWidth={true}
												name="SMTPHost"
												value={SMTPHost || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="SMTP Port"
												fullWidth={true}
												name="SMTPPort"
												value={SMTPPort || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "number")}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<TextField
										size="small"
										color="primary"
										autoFocus={true}
										type="string"
										variant="standard"

										label="Email From"
										fullWidth={true}
										name="EmailFrom"
										value={EmailFrom}
										onChange={(e) => onInputChange(e)}
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}
									></TextField>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												label="SMTP User Name"
												fullWidth={true}
												variant="standard"

												name="SMTPUserName"
												value={SMTPUserName || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>

								<div style={{ marginTop: "1.5rem" }}>
									{" "}
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												size="small"
												color="primary"
												autoFocus={true}
												variant="standard"

												label="SMTP Password"
												fullWidth={true}
												name="SMTPPassword"
												value={SMTPPassword || ""}
												onChange={(e) => onInputChange(e)}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
										</FormControl>
									</FormGroup>
								</div>
								{/* <Grid item xs={12} md={2} lg={2}></Grid>  */}
								<div style={{ marginTop: "1.5rem", float: "right" }}>
									{/* <Button
										style={{
											backgroundColor: "#fff",
											color: "#000"
										}}
										variant="contained"
										onClick={handleClose}
									>
										Cancel
									</Button> */}
									<CustomButton

										variant="contained"
										onClick={handleClose}
									>
										Cancel
									</CustomButton>
									<CustomButton
										style={{
											marginLeft: "15px"
										}}
										variant="contained"
										onClick={updateWalletOwnerRequest}
									>
										Edit
									</CustomButton>
									{/* <Button
										style={{
											backgroundColor: "#00b9f5",
											color: "white",
											marginLeft: "15px"
										}}
										variant="contained"
										onClick={updateWalletOwnerRequest}
									>
										Edit
									</Button> */}
								</div>
							</Grid>

							{/* <Grid item xs={12} md={2} lg={2}></Grid> */}
						</Grid>
					</Grid>
				</Card>
			</Layout>

			{updateWalletOwnerSettingArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWalletOwnerSettingArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateWalletOwnerSettingArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWalletOwnerSettingArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminWalletOwnerUpdate;
